"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("./env");
var $injectMark = Symbol.for('reactive-localstorage-inject-mark');
var $handlers = Symbol.for('reactive-localstorage-handlers');
var LocalStorage = /** @class */ (function () {
    function LocalStorage(window, storage) {
        var _this = this;
        this._events = {};
        this._length = 0;
        // istanbul ignore next
        if (window) {
            this.supported = true;
        }
        else {
            this.supported = false;
            window = new Window();
        }
        this.native = storage || window.localStorage;
        this._cache = new Map();
        this.inject(this.native);
        listen(window, function (_a) {
            var key = _a.key, newValue = _a.newValue, oldValue = _a.oldValue;
            _this.feed(key, newValue, oldValue);
        });
    }
    Object.defineProperty(LocalStorage.prototype, "version", {
        get: function () {
            return env_1.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalStorage.prototype, "length", {
        get: function () {
            return this.native.length;
        },
        enumerable: true,
        configurable: true
    });
    LocalStorage.prototype.key = function (index) {
        return this.native.key(index);
    };
    LocalStorage.prototype.getItem = function (key) {
        var cache = this._cache;
        if (cache.has(key))
            return cache.get(key);
        var value = getNative('getItem').call(this.native, key);
        cache.set(key, value);
        return value;
    };
    LocalStorage.prototype.setItem = function (key, value) {
        return this.set(key, value);
    };
    LocalStorage.prototype.removeItem = function (key) {
        return this.set(key, null);
    };
    LocalStorage.prototype.clear = function () {
        var e_1, _a;
        getNative('clear').call(this.native);
        var cache = this._cache;
        try {
            for (var _b = __values(cache.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                cache.set(key, null);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    LocalStorage.prototype.on = function (name, fn) {
        var set = this._events[name];
        if (!set) {
            this._events[name] = set = new Set();
        }
        set.add(fn);
    };
    LocalStorage.prototype.off = function (name, fn) {
        var set = this._events[name];
        if (set) {
            set.delete(fn);
        }
    };
    LocalStorage.prototype.feed = function (key, newValue, oldValue) {
        if (typeof key === 'string') {
            this._cache.set(key, newValue);
            if (newValue !== oldValue) {
                try {
                    this.emit('change', key, newValue, oldValue);
                }
                catch (e) {
                    // tslint:disable-next-line no-console
                    console.error(e);
                }
            }
        }
        else {
            this._cache.clear();
            try {
                this.emit('change', key, newValue, oldValue);
            }
            catch (e) {
                // tslint:disable-next-line no-console
                console.error(e);
            }
        }
    };
    LocalStorage.prototype.set = function (key, value) {
        var cache = this._cache;
        var oldValue = cache.has(key) ? cache.get(key) : getNative('getItem').call(this.native, key);
        if (typeof value === 'string') {
            getNative('setItem').call(this.native, key, value);
        }
        else {
            getNative('removeItem').call(this.native, key);
        }
        cache.set(key, value);
        this.emit('change', key, value, oldValue);
    };
    LocalStorage.prototype.emit = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var e_2, _a;
        var set = this._events[name];
        if (set) {
            try {
                for (var _b = __values(set.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var fn = _c.value;
                    fn.apply(null, args);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    LocalStorage.prototype.inject = function (storage) {
        var me = this;
        var cache = this._cache;
        var handlers = storage[$handlers] || (storage[$handlers] = []);
        handlers.push({
            injector: this,
            getItem: function (key, value) {
                cache.set(key, String(value));
            },
            setItem: function (key, value) {
                me.feed(key, String(value), me.getItem(key));
            },
            removeItem: function (key) {
                me.feed(key, null, me.getItem(key));
            },
            clear: function () {
                me.feed(null, null, null);
            },
        });
    };
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;
function listen(target, cb) {
    if (target.addEventListener) {
        target.addEventListener('storage', cb, true);
        // istanbul ignore next
    }
    else if (target.attachEvent) {
        target.attachEvent('storage', cb);
        // istanbul ignore next
    }
    else {
        return false;
    }
    return true;
}
inject();
function inject() {
    var _a;
    // istanbul ignore next
    if (Storage.prototype[$injectMark]) {
        console.warn("Storage has been injected, there might be multi versions of reactive-localstorage");
        return;
    }
    var _b = Storage.prototype, nativeGetItem = _b.getItem, nativeSetItem = _b.setItem, nativeRemoveItem = _b.removeItem, nativeClear = _b.clear;
    function injectedGetItem(key) {
        var e_3, _a;
        var value = nativeGetItem.call(this, key);
        var handlers = this[$handlers];
        if (handlers) {
            try {
                for (var handlers_1 = __values(handlers), handlers_1_1 = handlers_1.next(); !handlers_1_1.done; handlers_1_1 = handlers_1.next()) {
                    var fn = handlers_1_1.value.getItem;
                    if (typeof fn === 'function') {
                        fn.call(this, key, value);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (handlers_1_1 && !handlers_1_1.done && (_a = handlers_1.return)) _a.call(handlers_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return value;
    }
    injectedGetItem.native = nativeGetItem;
    function injectedSetItem(key, value) {
        var e_4, _a;
        var handlers = this[$handlers];
        if (handlers) {
            try {
                for (var handlers_2 = __values(handlers), handlers_2_1 = handlers_2.next(); !handlers_2_1.done; handlers_2_1 = handlers_2.next()) {
                    var fn = handlers_2_1.value.setItem;
                    if (typeof fn === 'function') {
                        fn.call(this, key, value);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (handlers_2_1 && !handlers_2_1.done && (_a = handlers_2.return)) _a.call(handlers_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        return nativeSetItem.call(this, key, value);
    }
    injectedSetItem.native = nativeSetItem;
    function injectedRemoveItem(key) {
        var e_5, _a;
        var handlers = this[$handlers];
        if (handlers) {
            try {
                for (var handlers_3 = __values(handlers), handlers_3_1 = handlers_3.next(); !handlers_3_1.done; handlers_3_1 = handlers_3.next()) {
                    var fn = handlers_3_1.value.removeItem;
                    if (typeof fn === 'function') {
                        fn.call(this, key);
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (handlers_3_1 && !handlers_3_1.done && (_a = handlers_3.return)) _a.call(handlers_3);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        return nativeRemoveItem.call(this, key);
    }
    injectedRemoveItem.native = nativeRemoveItem;
    function injectedClear() {
        var e_6, _a;
        var handlers = this[$handlers];
        if (handlers) {
            try {
                for (var handlers_4 = __values(handlers), handlers_4_1 = handlers_4.next(); !handlers_4_1.done; handlers_4_1 = handlers_4.next()) {
                    var fn = handlers_4_1.value.clear;
                    if (typeof fn === 'function') {
                        fn.call(this);
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (handlers_4_1 && !handlers_4_1.done && (_a = handlers_4.return)) _a.call(handlers_4);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        return nativeClear.call(this);
    }
    injectedRemoveItem.native = nativeRemoveItem;
    Object.defineProperties(Storage.prototype, (_a = {},
        _a[$injectMark] = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: true,
        },
        _a[$handlers] = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: [],
        },
        _a.getItem = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: injectedGetItem,
        },
        _a.setItem = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: injectedSetItem,
        },
        _a.removeItem = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: injectedRemoveItem,
        },
        _a.clear = {
            configurable: true,
            enumerable: false,
            writable: true,
            value: injectedClear,
        },
        _a));
}
function getNative(key) {
    var fn = Storage.prototype[key];
    return fn && fn.native || fn;
}
//# sourceMappingURL=data:application/json;base64,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